package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initFeb192018MarketmlmMigratingToKMPpart2Page(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/feb192018MarketmlmMigratingToKMPpart2.md", FrontMatterElement.Builder { addScalar("title", "19feb2018MarketmlmMigratingToKMPpart2"); }))
}

@Page("/worklog/marketmlm/feb192018-marketmlm-migrating-to-km-ppart2")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Feb192018MarketmlmMigratingToKMPpart2Page() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("feb-19-2018-marketmlm-migrating-to-kmp-part-2")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("As we figure out what deps need to be refactored in order to migrate to KMP. we faced other problems. this issue was kind of new for us, but nothing that we couldn't handel. in this challenge we had a couple of impl that was not currently supported in KMP. I can mention:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("permission handling")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("selecting from gallery")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Capturing from Camera")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("handling webview content")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("playing product demo video & voices")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("showing notifications")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At this time there was not any library in KMP that could handle above cases. now thanks to a unique ability in kmp called platform specific implementation we handled all above case using expect/actual mechanism. this mechanism was a kind of dependency injection that was handled by kmp platform itself. here is how it works:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("we write our api in commonMain with ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("expect")
            }
            org.jetbrains.compose.web.dom.Text(" syntaxt")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("then we implement that api in each platfrom with ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("actual")
            }
            org.jetbrains.compose.web.dom.Text(" syntax")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("implementing each feature was a little time consuming but the result was amazing becuese the impl was native for each platform, the ux got a huge thumsup.")
    }
}
